module.exports = __webpack_public_path__ + "static/media/IMG_0547.40f3a59d.jpg";